var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress mb-2"},[(_vm.width)?_c('div',{class:_vm.progressClass,style:({ 'max-width': (_vm.width) + '%' }),attrs:{"role":"progressbar"}},[(_vm.width)?_c('span',{staticClass:"title"},[_vm._v(_vm._s(this.width)+"%")]):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e30fae4","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/progressbar/BootstrapProgressBar.vue
// module id = 1772
// module chunks = 27